import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { RootProps } from './types.js';

/** `<Root>` component. */
export const Root = ({ children, className, ...props }: RootProps): ReactElement => (
  <div
    className={twMerge(
      'flex h-40 items-center justify-between border-b border-base-100 bg-base-200 px-12',
      className
    )}
    {...props}
  >
    {children}
  </div>
);
